import { MessageWindow } from '@repo/studio-components/message-window'
import { Button } from '@repo/studio-design-system-ui-button'
import { AnimatePresence, m } from 'framer-motion'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { usePaymentsDialog } from '@repo/studio-hooks-payments/use-payments-dialog'
import 'payments/payments-dialog/styles.css'

export function GoUnlimitedMessage({ className, show }: { className?: string; show: boolean }) {
  const t = useStudioTranslate()
  const { open: openPaymentsModal } = usePaymentsDialog()

  return (
    <AnimatePresence initial={false}>
      {show ? (
        <m.div
          className={className}
          initial={{
            opacity: 0,
          }}
          animate={{ opacity: 1, transition: { duration: 0.2, delay: 0.2 } }}
          exit={{
            opacity: 0,
            transition: { duration: 0 },
          }}
        >
          <MessageWindow variant="3d" className="overflow-clip">
            <span className="typography-13 font-bold">
              {t('studio.components.go_unlimited_message.title')}
            </span>
            <span className="typography-13 text-gray-300">
              {t('studio.components.go_unlimited_message.content')}
            </span>
            <Button
              size="sm"
              variant="promotional"
              onClick={() => openPaymentsModal('studioUnlimited')}
            >
              {t('studio.components.go_unlimited_message.cta')}
            </Button>
          </MessageWindow>
        </m.div>
      ) : null}
    </AnimatePresence>
  )
}
